import React from 'react';
import { getErrorToast } from '../../toast';

const NumberInput = ({
    value,
    handler,
    isDisabled=false,
    idx=null
}) => {
    const numberChangeHandeler = event => {
        handler(event.target.value, idx)
    }
    return (
        <input 
            type="number" 
            name=""
            id=""
            className="enter-details-input"
            value={value}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
            onChange={numberChangeHandeler}
            style={{width: '50%'}}
            step="any"
            required={true}
            disabled={isDisabled}
        />
    );
}

export default NumberInput;
